import { useState } from 'react'

const PASSWORD_FIELDS = ['password', 'repeatPassword'] as const

type PasswordFieldName = (typeof PASSWORD_FIELDS)[number]

type PasswordVisibilityProps = {
  passwordVisible?: boolean
  onPasswordVisibleChange?: (visible: boolean) => void
}

const HIDDEN_PASSWORDS: Record<PasswordFieldName, boolean> = {
  password: false,
  repeatPassword: false,
}

const isPasswordFieldName = (name: string): name is PasswordFieldName =>
  (PASSWORD_FIELDS as readonly string[]).includes(name)

export const usePasswordVisibility = () => {
  const [visiblePasswords, setVisiblePasswords] = useState(HIDDEN_PASSWORDS)

  const showPasswords = () =>
    setVisiblePasswords({ password: true, repeatPassword: true })

  const getVisibilityProps = (name: string): PasswordVisibilityProps => {
    if (!isPasswordFieldName(name)) return {}
    return {
      passwordVisible: visiblePasswords[name],
      onPasswordVisibleChange: (visible) =>
        setVisiblePasswords((current) => ({ ...current, [name]: visible })),
    }
  }

  return { showPasswords, getVisibilityProps }
}
